module.exports = __webpack_public_path__ + "static/media/josh_pollock.4b785a71.jpg";